import {
  ESTUDIOGRUPO_SUCCESS,
  ESTUDIOGRUPO_LOADING,
  ESTUDIOGRUPO_ERROR,
  ESTUDIOMASBUSCADO_SUCCESS,
  ESTUDIOMASBUSCADO_LOADING,
  ESTUDIOMASBUSCADO_ERROR,
  ESTUDIOMASBUSCADO_RESET,
  ESTUDIOGRUPO_RESET,
  ESTUDIOGRUPO_FILTRAR_POR_EDAD,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

// Función auxiliar para filtrar grupos por edad
const filtrarGruposPorEdad = (grupos, edad) => {
  if (edad === undefined || edad === null) return grupos;
  
  return grupos.filter((grupo) => {
    const min = grupo.filtroEdadMin || 0;
    const max = grupo.filtroEdadMax || 0;

    // Sin filtro: ambos son 0 O max >= 999
    const sinFiltro = (min === 0 && max === 0) || max >= 999;
    if (sinFiltro) return true;

    // Con filtro: validar rango
    const cumpleMin = min === 0 || edad >= min;
    const cumpleMax = max === 0 || edad <= max;

    return cumpleMin && cumpleMax;
  });
};

export const estudioGrupo = (paciente) => (dispatch) => {
  dispatch({
    type: ESTUDIOGRUPO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/estudios/grupos`)
      .then((res) => {
        // Normalizar descripción a mayúsculas
        const dataOriginal = res.data.map((grupo) => ({
          ...grupo,
          descripcion: grupo.descripcion?.toUpperCase() || grupo.descripcion,
        }));

        // Filtrar por edad del paciente principal (si existe)
        const dataFiltrada = paciente 
          ? filtrarGruposPorEdad(dataOriginal, paciente.edad)
          : dataOriginal;

        dispatch({
          type: ESTUDIOGRUPO_SUCCESS,
          payload: { dataOriginal, dataFiltrada },
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ESTUDIOGRUPO_ERROR,
          payload: error,
        });
      });
  });
};
// export const estudioGrupo = () => (dispatch) => {
//   dispatch({
//     type: ESTUDIOGRUPO_LOADING,
//   });
//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get(`/estudios/grupos`)
//       .then((res) => {
//         dispatch({
//           type: ESTUDIOGRUPO_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: ESTUDIOGRUPO_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

/* export const estudiosMasSolicitadosPorPaciente =
  (idPacFamiliar) => (dispatch) => {
    dispatch({
      type: ESTUDIOMASBUSCADO_LOADING,
    });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/estudios/grupos/paraPaciente/${idPacFamiliar ? idPacFamiliar : -1}`
        )
        .then((res) => {
          dispatch({
            type: ESTUDIOMASBUSCADO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ESTUDIOMASBUSCADO_ERROR,
            payload: error,
          });
        });
    });
  }; */

export const estudiosMasSolicitadosPorPaciente =
  (idPacFamiliar) => (dispatch) => {
    dispatch({
      type: ESTUDIOMASBUSCADO_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/estudios/grupos/paraPaciente/${
            idPacFamiliar ? idPacFamiliar : -1
          }`
        )
        .then((res) => {
          dispatch({
            type: ESTUDIOMASBUSCADO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: ESTUDIOMASBUSCADO_ERROR,
            payload: error,
          });
        });
    });
  };

export const resetEstudioMasBuscado = () => (dispatch) => {
  dispatch({
    type: ESTUDIOMASBUSCADO_RESET,
  });
};

export const resetEstudioGrupo = () => (dispatch) => {
  dispatch({
    type: ESTUDIOGRUPO_RESET,
  });
};

// Filtra los grupos de estudio según la edad del paciente/familiar seleccionado
// Usa dataOriginal del estado para re-filtrar
export const filtrarEstudioGrupoPorEdad = (dataOriginal, paciente) => (dispatch) => {
  if (!dataOriginal) return;
  
  const edad = paciente?.edad;
  const dataFiltrada = filtrarGruposPorEdad(dataOriginal, edad);
  
  dispatch({
    type: ESTUDIOGRUPO_FILTRAR_POR_EDAD,
    payload: dataFiltrada,
  });
};
